import { Builder } from '@builder.io/react'
import ErrorToast from 'components/ui/toast/ErrorToast'
import Toast from 'components/ui/toast/Toast'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { Field, Formik, useFormikContext } from 'formik'
import FormikErrorFocus from 'formik-error-focus'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect, useState } from 'react'
import Api from 'state/apis/api'
import { ContactUsSchema } from 'utils/yup-validation-schema'
import defaultBackground from '../../../images/contact-us-bg.png'

import * as yup from 'yup'

enum FormType {
  Old = 'old',
  New = 'new'
}
interface Props {
  backgroundColor: string
  formBackgroundColor: string
  backgroundImage: any
  contactInfoRichText: string
  buttonColor: string
  buttonTextColor: string
  // cloudinaryImage: any
  builderImage: any
  builderMobileImage: any
  cloudinaryMobileImage: any
  imageAltText: string
  showImage: boolean
  title: string
  showTitle: boolean
  headlineOne: string
  headlineTwo: string
  showHeadlineOne: boolean
  showHeadlineTwo: boolean
  formType: FormType
  placeholder: boolean
  formFieldNameShow: boolean
  formFieldSurnameShow: boolean
  formFieldEmailShow: boolean
  formFieldPhoneShow: boolean
  formFieldHandleShow: boolean
  formFieldSubjectShow: boolean
  formFieldMessageShow: boolean
  formFieldMessagePlaceholder: string
  footerImage: any
  footerImageMobile: any
  contactType: string
  showEmbedForm: boolean
  embedForm: string
}

const ContactUs = ({
  backgroundColor,
  formBackgroundColor,
  backgroundImage = '',
  contactInfoRichText,
  buttonColor,
  buttonTextColor,
  // cloudinaryImage,
  cloudinaryMobileImage,
  builderImage,
  builderMobileImage,
  imageAltText,
  showImage,
  title,
  showTitle,
  headlineOne,
  headlineTwo,
  showHeadlineOne,
  showHeadlineTwo,
  formType,
  placeholder,
  formFieldNameShow,
  formFieldSurnameShow,
  formFieldEmailShow,
  formFieldPhoneShow,
  formFieldHandleShow,
  formFieldSubjectShow,
  formFieldMessageShow,
  formFieldMessagePlaceholder,
  footerImage,
  footerImageMobile,
  contactType,
  showEmbedForm = false,
  embedForm
}: Props) => {
  const formikRef = React.useRef<any>()
  const [showToast, setShowToast] = React.useState(false)
  const [showError, setErrorToast] = React.useState(false)
  const [fields, setFields] = useState<string[]>([])
  const [cookiesEnabled, setCookiesEnabled] = useState(true)
  const [cookiebotLoaded, setCookiebotLoaded] = useState(false)

  useEffect(() => {
    // Check CookieConsent exists
    function checkCookieConsent() {
      setCookiebotLoaded(typeof window?.Cookiebot !== 'undefined')
      const cookieConsentMatch = document.cookie.match(/CookieConsent=([^;]+)/)

      if (cookieConsentMatch && cookieConsentMatch.length > 1) {
        const preferencesEnabled = cookieConsentMatch[1].includes('preferences:true')
        setCookiesEnabled(preferencesEnabled)
      } else {
        setCookiesEnabled(false)
      }
    }
    checkCookieConsent()
    const intervalId = setInterval(() => {
      checkCookieConsent()
    }, 1000) // Check every 1 second if consent accepted
    return () => clearInterval(intervalId)
  }, [])

  // Fields not included
  useEffect(() => {
    const fields: any = []
    if (!formFieldNameShow || formType === 'new') {
      fields.push('formFieldName')
    }
    if (!formFieldSurnameShow || formType === 'new') {
      fields.push('formFieldSurname')
    }
    if (!formFieldEmailShow || formType === 'new') {
      fields.push('formFieldEmail')
    }
    if (!formFieldPhoneShow || formType === 'new') {
      fields.push('formFieldPhone')
    }
    if (!formFieldHandleShow || formType === 'new') {
      fields.push('formFieldHandle')
    }
    if (!formFieldSubjectShow || formType === 'new') {
      fields.push('formFieldSubject')
    }
    if (!formFieldMessageShow || formType === 'new') {
      fields.push('formFieldMessage')
    }
    setFields(fields)
  }, [])

  const ExtendedContactUsSchema = ContactUsSchema.shape({
    name: yup.string().when([], {
      is: () => formFieldNameShow && formType === 'old',
      then: yup.string().required('Please enter your name'),
      otherwise: yup.string()
    }),
    surname: yup.string().when([], {
      is: () => formFieldSurnameShow && formType === 'old',
      then: yup.string().required('Please enter your surname'),
      otherwise: yup.string()
    }),
    email: yup.string().when([], {
      is: () => formFieldEmailShow && formType === 'old',
      then: yup
        .string()
        .matches(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          'Invalid email address'
        )
        .required('Email is required'),
      otherwise: yup
        .string()
        .matches(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          'Invalid email address'
        )
    }),
    handle: yup.string().when([], {
      is: () => formFieldHandleShow && formType === 'old',
      then: yup.string().required('Please enter your social media handle '),
      otherwise: yup.string()
    }),
    subject: yup.string().when([], {
      is: () => formFieldSubjectShow && formType === 'old',
      then: yup.string().required('Please enter subject'),
      otherwise: yup.string()
    }),
    message: yup.string().when([], {
      is: () => formFieldMessageShow && formType === 'old',
      then: yup.string().max(500, 'Message must be at most 500 characters').required('Please enter message'),
      otherwise: yup.string().max(500, 'Message must be at most 500 characters')
    })
  })

  const handleSetShowToast = (show: boolean) => {
    setShowToast(show)
  }

  const handleSetErrorToast = (show: boolean) => {
    setErrorToast(show)
  }

  const getRowNumber = () => {
    if (formType === 'old') {
      return 4
    } else {
      return 1
    }
  }

  const renderImage = (view: string) => {
    if (view === 'desktop') {
      return (
        <CdnImage
          className="lg:block object-contain lg:h-auto aspect-auto lg:w-full hidden justify-center mx-auto"
          url={builderImage}
          alt={imageAltText}
          steps={[705]}
          style={{
            maxHeight: '100%',
            maxWidth: '100%'
          }}
        />
        // <>
        //   {builderImage ? (
        //     <CdnImage
        //       className="lg:block object-contain lg:h-auto aspect-auto lg:w-1/3 xl:w-2/5 hidden"
        //       url={builderImage}
        //       alt={imageAltText}
        //       steps={[705]}
        //       style={{
        //         maxHeight: '100%',
        //         maxWidth: '100%'
        //       }}
        //     />
        //   ) : (
        //     <CloudinaryImage
        //       className="lg:block object-contain lg:h-auto aspect-auto lg:w-1/3 xl:w-2/5 hidden"
        //       publicId={cloudinaryImage?.public_id}
        //       alt={imageAltText}
        //       steps={[705]}
        //       style={{
        //         maxHeight: '100%',
        //         maxWidth: '100%'
        //       }}
        //     />
        //   )}
        // </>
      )
    }
    if (view === 'mobile') {
      return (
        <CdnImage
          className="lg:hidden h-auto w-2/3 object-contain aspect-auto block justify-center mx-auto"
          url={builderMobileImage}
          alt={imageAltText}
          steps={[705]}
          style={{
            maxHeight: '100%',
            maxWidth: '100%'
          }}
        />
        // <>
        //   {builderMobileImage ? (
        //     <CdnImage
        //       className="lg:hidden h-auto w-2/3 object-contain aspect-auto block"
        //       url={builderMobileImage}
        //       alt={imageAltText}
        //       steps={[705]}
        //       style={{
        //         maxHeight: '100%',
        //         maxWidth: '100%'
        //       }}
        //     />
        //   ) : (
        //     <CloudinaryImage
        //       className="lg:hidden h-auto w-2/3 object-contain aspect-auto block"
        //       publicId={cloudinaryMobileImage?.public_id}
        //       alt={imageAltText}
        //       steps={[705]}
        //       style={{
        //         maxHeight: '100%',
        //         maxWidth: '100%'
        //       }}
        //     />
        //   )}
        // </>
      )
    }
  }

  return (
    <>
      <section
        className="h-full lg:h-screen container flex justify-center mx-auto"
        style={{ backgroundColor: backgroundColor || 'transparent' }}
      >
        <div className={`h-full py-12 ${formType === 'old' ? 'px-6' : 'px-0'}`}>
          <div
            className={`g-6 flex h-full ${
              formType === 'old' ? 'flex-wrap' : 'flex-col'
            } items-center justify-center text-gray-800`}
          >
            <div className={`w-full ${formType === 'old' ? 'xl:w-3/4' : 'lg:w-3/4'}`}>
              <div
                className={`block ${
                  formType === 'old' ? 'rounded-lg drop-shadow-lg' : 'rounded-none lg:rounded-t-3xl p-4'
                }`}
                style={{ backgroundColor: formBackgroundColor || 'white' }}
              >
                {showImage && (
                  <div className="flex justify-center items-center w-full lg:w-1/2 ">{renderImage('mobile')}</div>
                )}
                {showTitle && (
                  <div
                    className=" flex mx-auto text-base lg:mx-6 lg:px-6 pt-6 pb-2 justify-center items-center font-serif font-medium text-2xl text-center"
                    dangerouslySetInnerHTML={{ __html: title }}
                  />
                )}
                {showHeadlineOne && (
                  <div
                    className=" flex mx-auto text-base md:mx-6 p-2 justify-center items-center font-sans font-normal text-sm lg:text-lg text-center"
                    dangerouslySetInnerHTML={{ __html: headlineOne }}
                  />
                )}
                <div className={`lg:flex ${showImage ? 'justify-center items-center' : 'lg:flex-wrap'}`}>
                  {!showImage && (
                    <div
                      className="flex rounded-t-lg bg-gradient-to-t pt-5 lg:w-4/12 lg:rounded-l-lg lg:rounded-tr-none"
                      style={{
                        backgroundImage: `url(${backgroundImage || defaultBackground})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat'
                      }}
                    >
                      <div
                        className="px-4 py-6 text-white md:mx-6 md:p-6"
                        dangerouslySetInnerHTML={{ __html: contactInfoRichText }}
                      />
                    </div>
                  )}
                  <div className="flex w-1/2">{showImage && renderImage('desktop')}</div>
                  <div className="px-4 md:px-0 lg:w-1/2">
                    <div className={` ${formType === 'old' ? 'md:p-12 md:mx-6' : ' mx-2'}`}>
                      <Formik
                        innerRef={formikRef}
                        initialValues={{
                          name: '',
                          surname: '',
                          email: '',
                          telephone: '',
                          handle: '',
                          subject: '',
                          message: ''
                        }}
                        onSubmit={(values, { resetForm }) => {
                          const { name, surname, email, telephone, handle, message, subject } = values
                          Api.post('wwwREST', '/v1/public/contact', {
                            body: {
                              name: name,
                              surname: surname,
                              email: email,
                              telephone: telephone,
                              handle: handle,
                              subject: subject,
                              message: message,
                              fields,
                              type: contactType
                            }
                          })
                            .then((res: any) => {
                              console.log(JSON.stringify(res))
                              // If it falls into here, response is 200
                              resetForm()
                              setShowToast(true)
                            })
                            .catch(() => {
                              setErrorToast(true)
                            })
                        }}
                        validationSchema={ExtendedContactUsSchema}
                        validateOnMount={false}
                      >
                        {props => {
                          function checkInputState(fieldName: string) {
                            if (!props.errors[fieldName] && props.values[fieldName]) {
                              return 'field-success'
                            } else if (props.errors?.[fieldName] && props.touched?.[fieldName]) {
                              return 'field-error'
                            }
                            return 'field-focus'
                          }

                          return (
                            <>
                              <FormikErrorFocus
                                formik={useFormikContext()}
                                offset={0}
                                align={'middle'}
                                focusDelay={1000}
                                ease={'linear'}
                                duration={1000}
                              />
                              <div className="overflow-hidden sm:rounded-md">
                                <div className={`${formType === 'old' ? 'bg-white' : 'bg-none'} px-4 py-5 sm:p-6`}>
                                  {showHeadlineTwo && <p className="font-semibold">{headlineTwo}</p>}
                                  <div className="mt-3 grid grid-cols-6 gap-6">
                                    {formFieldNameShow && (
                                      <div className="col-span-6 sm:col-span-3">
                                        <div
                                          className={`${
                                            placeholder
                                              ? 'relative flex w-full flex-shrink-0 flex-row items-center'
                                              : ''
                                          }`}
                                        >
                                          {!placeholder && (
                                            <label htmlFor="name" className="text-black-700 block text-sm font-medium">
                                              Name
                                            </label>
                                          )}
                                          <Field
                                            type="text"
                                            name="name"
                                            label="name"
                                            id="name"
                                            className={`${checkInputState('name')} block w-full ${
                                              formType === 'old' ? 'rounded-md' : 'rounded-full'
                                            } border border-gray-300 bg-white py-3 px-4 text-center focus:border-highlight focus:ring-highlight sm:mr-2`}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                              props.setFieldValue('name', e.target.value)
                                            }}
                                          />
                                          {placeholder && (
                                            <label
                                              onClick={() => {
                                                document.querySelector('.name')?.focus()
                                              }}
                                              className={`absolute top-[3px] inline-flex h-[80%] w-full text-base font-medium transform cursor-text appearance-none items-center justify-center duration-300 peer-focus:ml-0 peer-focus:-translate-y-3 peer-focus:scale-75 ${
                                                props.values.name || props.touched.name
                                                  ? 'ml-0 -translate-y-[0.80rem] scale-75'
                                                  : ''
                                              }`}
                                              htmlFor="name"
                                            >
                                              First name
                                            </label>
                                          )}
                                        </div>
                                        {props.errors.name ? (
                                          <div
                                            className={`${
                                              formType === 'old' ? 'text-xs' : 'text-sm text-center mx-auto'
                                            } text-red-500`}
                                          >
                                            {props.errors.name}
                                          </div>
                                        ) : null}
                                      </div>
                                    )}
                                    {formFieldSurnameShow && (
                                      <div className="col-span-6 sm:col-span-3">
                                        <div
                                          className={`${
                                            placeholder
                                              ? 'relative flex w-full flex-shrink-0 flex-row items-center'
                                              : ''
                                          }`}
                                        >
                                          {!placeholder && (
                                            <label
                                              htmlFor="surname"
                                              className="text-black-700 block text-sm font-medium"
                                            >
                                              Surname
                                            </label>
                                          )}
                                          <Field
                                            type="text"
                                            name="surname"
                                            label="surname"
                                            id="surname"
                                            className={`${checkInputState('surname')} block w-full ${
                                              formType === 'old' ? 'rounded-md' : 'rounded-full'
                                            } border border-gray-300 bg-white py-3 px-4 text-center focus:border-highlight focus:ring-highlight sm:mr-2`}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                              props.setFieldValue('surname', e.target.value)
                                            }}
                                          />
                                          {placeholder && (
                                            <label
                                              onClick={() => {
                                                document.querySelector('.surname')?.focus()
                                              }}
                                              className={`absolute top-[3px] inline-flex h-[80%] w-full text-base font-medium transform cursor-text appearance-none items-center justify-center duration-300 peer-focus:ml-0 peer-focus:-translate-y-3 peer-focus:scale-75 ${
                                                props.values.surname || props.touched.surname
                                                  ? 'ml-0 -translate-y-[0.80rem] scale-75'
                                                  : ''
                                              }`}
                                              htmlFor="surname"
                                            >
                                              Last name
                                            </label>
                                          )}
                                        </div>
                                        {props.errors.surname && props.touched.surname ? (
                                          <div
                                            className={`${
                                              formType === 'old' ? 'text-xs' : 'text-sm text-center mx-auto'
                                            } text-red-500`}
                                          >
                                            {props.errors.surname}
                                          </div>
                                        ) : null}
                                      </div>
                                    )}
                                    {formFieldEmailShow && (
                                      <div
                                        className={`${
                                          formType === 'new' ? 'sm:col-span-6' : 'sm:col-span-3'
                                        } col-span-6`}
                                      >
                                        <div
                                          className={`${
                                            placeholder
                                              ? 'relative flex w-full flex-shrink-0 flex-row items-center'
                                              : ''
                                          }`}
                                        >
                                          {!placeholder && (
                                            <label htmlFor="email" className="text-black-700 block text-sm font-medium">
                                              Email address
                                            </label>
                                          )}
                                          <Field
                                            type="text"
                                            name="email"
                                            label="email"
                                            id="email"
                                            className={`${checkInputState('email')} block w-full ${
                                              formType === 'old' ? 'rounded-md' : 'rounded-full'
                                            } border border-gray-300 bg-white py-3 px-4 text-center focus:border-highlight focus:ring-highlight sm:mr-2`}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                              props.setFieldValue('email', e.target.value)
                                            }}
                                          />
                                          {placeholder && (
                                            <label
                                              onClick={() => {
                                                document.querySelector('.email')?.focus()
                                              }}
                                              className={`absolute top-[3px] inline-flex h-[80%] w-full text-base font-medium transform cursor-text appearance-none items-center justify-center duration-300 peer-focus:ml-0 peer-focus:-translate-y-3 peer-focus:scale-75 ${
                                                props.values.email || props.touched.email
                                                  ? 'ml-0 -translate-y-[0.80rem] scale-75'
                                                  : ''
                                              }`}
                                              htmlFor="email"
                                            >
                                              Email address
                                            </label>
                                          )}
                                        </div>
                                        {props.errors.email && props.touched.email ? (
                                          <div
                                            className={`${
                                              formType === 'old' ? 'text-xs' : 'text-sm text-center mx-auto'
                                            } text-red-500`}
                                          >
                                            {props.errors.email}
                                          </div>
                                        ) : null}
                                      </div>
                                    )}
                                    {formFieldPhoneShow && (
                                      <div
                                        className={`${
                                          formType === 'new' ? 'sm:col-span-6' : 'sm:col-span-3'
                                        } col-span-6`}
                                      >
                                        <div
                                          className={`${
                                            placeholder
                                              ? 'relative flex w-full flex-shrink-0 flex-row items-center'
                                              : ''
                                          }`}
                                        >
                                          {!placeholder && (
                                            <div className="flex w-full justify-between">
                                              <label
                                                htmlFor="telephone"
                                                className="text-black-700 block text-sm font-medium"
                                              >
                                                Telephone
                                              </label>
                                              <label
                                                htmlFor="telephone"
                                                className="block justify-items-end text-sm font-medium  text-gray-500"
                                              >
                                                Optional
                                              </label>
                                            </div>
                                          )}

                                          <Field
                                            type="text"
                                            name="telephone"
                                            label="telephone"
                                            id="telephone"
                                            className={`${checkInputState('telephone')} block w-full ${
                                              formType === 'old' ? 'rounded-md' : 'rounded-full'
                                            } border border-gray-300 bg-white py-3 px-4 text-center focus:border-highlight focus:ring-highlight sm:mr-2`}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                              props.setFieldValue('telephone', e.target.value)
                                            }}
                                          />
                                          {placeholder && (
                                            <label
                                              onClick={() => {
                                                document.querySelector('.telephone')?.focus()
                                              }}
                                              className={`absolute top-[3px] inline-flex h-[80%] w-full text-base font-medium transform cursor-text appearance-none items-center justify-center duration-300 peer-focus:ml-0 peer-focus:-translate-y-3 peer-focus:scale-75 ${
                                                props.values.telephone || props.touched.telephone
                                                  ? 'ml-0 -translate-y-[0.80rem] scale-75'
                                                  : ''
                                              }`}
                                              htmlFor="telephone"
                                            >
                                              Phone number
                                            </label>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    {formFieldHandleShow && (
                                      <div className="col-span-6">
                                        <div
                                          className={`${
                                            placeholder
                                              ? 'relative flex w-full flex-shrink-0 flex-row items-center'
                                              : ''
                                          }`}
                                        >
                                          {!placeholder && (
                                            <label
                                              htmlFor="handle"
                                              className="text-black-700 block text-sm font-medium"
                                            >
                                              Social media handle
                                            </label>
                                          )}
                                          <Field
                                            type="text"
                                            name="handle"
                                            label="handle"
                                            id="handle"
                                            className={`${checkInputState('handle')} block w-full ${
                                              formType === 'old' ? 'rounded-md' : 'rounded-full'
                                            } border border-gray-300 bg-white py-3 px-4 text-center focus:border-highlight focus:ring-highlight sm:mr-2`}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                              props.setFieldValue('handle', e.target.value)
                                            }}
                                          />
                                          {placeholder && (
                                            <label
                                              onClick={() => {
                                                document.querySelector('.handle')?.focus()
                                              }}
                                              className={`absolute top-[3px] inline-flex h-[80%] w-full text-base font-medium transform cursor-text appearance-none items-center justify-center duration-300 peer-focus:ml-0 peer-focus:-translate-y-3 peer-focus:scale-75 ${
                                                props.values.handle || props.touched.handle
                                                  ? 'ml-0 -translate-y-[0.80rem] scale-75'
                                                  : ''
                                              }`}
                                              htmlFor="handle"
                                            >
                                              Social media handle
                                            </label>
                                          )}
                                        </div>
                                        {props.errors.handle && props.touched.handle ? (
                                          <div
                                            className={`${
                                              formType === 'old' ? 'text-xs' : 'text-sm text-center mx-auto'
                                            } text-red-500`}
                                          >
                                            {props.errors.handle}
                                          </div>
                                        ) : null}
                                      </div>
                                    )}
                                    {formFieldSubjectShow && (
                                      <div className="col-span-6">
                                        <div
                                          className={`${
                                            placeholder
                                              ? 'relative flex w-full flex-shrink-0 flex-row items-center'
                                              : ''
                                          }`}
                                        >
                                          {!placeholder && (
                                            <label
                                              htmlFor="subject"
                                              className="text-black-700 block text-sm font-medium"
                                            >
                                              Subject
                                            </label>
                                          )}
                                          <Field
                                            type="text"
                                            name="subject"
                                            label="subject"
                                            id="subject"
                                            className={`${checkInputState('subject')} block w-full ${
                                              formType === 'old' ? 'rounded-md' : 'rounded-full'
                                            } border border-gray-300 bg-white py-3 px-4 text-center focus:border-highlight focus:ring-highlight sm:mr-2`}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                              props.setFieldValue('subject', e.target.value)
                                            }}
                                          />
                                          {placeholder && (
                                            <label
                                              onClick={() => {
                                                document.querySelector('.subject')?.focus()
                                              }}
                                              className={`absolute top-[3px] inline-flex h-[80%] w-full text-base font-medium transform cursor-text appearance-none items-center justify-center duration-300 peer-focus:ml-0 peer-focus:-translate-y-3 peer-focus:scale-75 ${
                                                props.values.subject || props.touched.subject
                                                  ? 'ml-0 -translate-y-[0.80rem] scale-75'
                                                  : ''
                                              }`}
                                              htmlFor="subject"
                                            >
                                              Subject
                                            </label>
                                          )}
                                        </div>
                                        {props.errors.subject && props.touched.subject ? (
                                          <div
                                            className={`${
                                              formType === 'old' ? 'text-xs' : 'text-sm text-center mx-auto'
                                            } text-red-500`}
                                          >
                                            {props.errors.subject}
                                          </div>
                                        ) : null}
                                      </div>
                                    )}
                                    {formFieldMessageShow && (
                                      <div className="col-span-6">
                                        <div
                                          className={`${
                                            placeholder
                                              ? 'relative flex w-full flex-shrink-0 flex-row items-center'
                                              : ''
                                          }`}
                                        >
                                          {!placeholder && (
                                            <div className="flex w-full justify-between">
                                              <label htmlFor="message" className="text-black-800 block text-sm">
                                                Message
                                              </label>
                                              <label
                                                htmlFor="message"
                                                className="block justify-items-end text-sm font-medium  text-gray-500"
                                              >
                                                Max. 500 Characters
                                              </label>
                                            </div>
                                          )}
                                          <Field
                                            component="textarea"
                                            rows={getRowNumber()}
                                            name="message"
                                            label="message"
                                            id="message"
                                            className={`${checkInputState('message')} block w-full ${
                                              formType === 'old' ? 'rounded-md' : 'rounded-[30px]'
                                            } border border-gray-300 bg-white py-3 px-4 text-center focus:border-highlight focus:ring-highlight sm:mr-2`}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                              props.setFieldValue('message', e.target.value)
                                            }}
                                          />
                                          {placeholder && (
                                            <label
                                              onClick={() => {
                                                document.querySelector('.message')?.focus()
                                              }}
                                              className={`absolute top-[3px] inline-flex h-[80%] w-full text-base font-medium transform cursor-text appearance-none items-center justify-center duration-300 peer-focus:ml-0 peer-focus:-translate-y-3 peer-focus:scale-75 ${
                                                props.values.message || props.touched.message
                                                  ? 'ml-0 -translate-y-[0.80rem] scale-75'
                                                  : ''
                                              }`}
                                              htmlFor="message"
                                            >
                                              {formFieldMessagePlaceholder}
                                            </label>
                                          )}
                                        </div>
                                        {props.errors.message && props.touched.message ? (
                                          <div
                                            className={`${
                                              formType === 'old' ? 'text-xs' : 'text-sm text-center mx-auto'
                                            } text-red-500`}
                                          >
                                            {props.errors.message}
                                          </div>
                                        ) : null}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {!showEmbedForm && (
                                  <div className="px-4 py-3 text-right sm:px-6 w-full">
                                    <button
                                      type="button"
                                      className={`inline-flex justify-center rounded-3xl border border-transparent py-2 px-4 text-sm font-medium text-white opacity-80 shadow-sm hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                                        formType === 'new' ? 'w-full' : ''
                                      }`}
                                      onClick={() => {
                                        props.handleSubmit()
                                      }}
                                      style={{ backgroundColor: buttonColor, color: buttonTextColor }}
                                    >
                                      Submit
                                    </button>
                                  </div>
                                )}
                              </div>
                              {showEmbedForm && (
                                //    <div
                                //    className=" flex mx-auto text-base md:mx-6 p-2 justify-center items-center font-sans font-normal text-sm lg:text-lg text-center"
                                //    dangerouslySetInnerHTML={{ __html: embedForm }}
                                //  />
                                // Crufts embeded form (hardcoded to stop box mis alignment)
                                <>
                                  <div className="klaviyo-form-SkGivw"></div>
                                  {!cookiesEnabled && (
                                    <div id="incognitoMessage">
                                      <p>Content unavailable.</p>
                                      {cookiebotLoaded && (
                                        <p>
                                          Please <a href="javascript:Cookiebot.renew()">accept preference cookies</a> to
                                          view this content.
                                        </p>
                                      )}
                                      {!cookiebotLoaded && <p>Please enable cookies to view this content.</p>}
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          )
                        }}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>

              {footerImage && (
                <div
                  className="relative mx-auto hidden h-20 w-full bg-contain bg-bottom bg-no-repeat lg:block -mt-8 xl:h-24 xl:-mt-6 2xl:h-32 2xl:-mt-10"
                  style={{ backgroundColor, backgroundImage: `url(${footerImage})` }}
                />
              )}
              {footerImageMobile && (
                <div
                  className="relative block lg:hidden h-24 bg-cover bg-bottom bg-no-repeat pb-4 w-full "
                  style={{ backgroundColor, backgroundImage: `url(${footerImageMobile})` }}
                />
              )}
            </div>
          </div>
          <ErrorToast
            showToast={showError}
            msg={'There has been a problem submitting the form, please try again.'}
            handleSetShowToast={handleSetErrorToast}
            handleOnClick={() => {}}
          />
          <Toast
            showToast={showToast}
            msg={'Thank you for getting in touch! We appreciate you contacting us'}
            handleSetShowToast={handleSetShowToast}
          />
        </div>
      </section>
    </>
  )
}

export default ContactUs

Builder.registerComponent(ContactUs, {
  name: 'ContactUs',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'transparent'
    },
    {
      name: 'formBackgroundColor',
      type: 'color',
      defaultValue: 'transparent'
    },
    {
      name: 'backgroundImage',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'contactInfoRichText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'buttonColor',
      type: 'color',
      defaultValue: 'emerald'
    },
    {
      name: 'buttonTextColor',
      type: 'color',
      defaultValue: 'emerald'
    },
    // {
    //   name: 'cloudinaryImage',
    //   type: 'cloudinaryImageEditor'
    // },
    // {
    //   name: 'cloudinaryMobileImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'builderMobileImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'showImage',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'showTitle',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'headlineOne',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'headlineTwo',
      type: 'text',
      defaultValue: 'Send us a message'
    },
    {
      name: 'showHeadlineOne',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'showHeadlineTwo',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'formType',
      type: 'string',
      enum: ['old', 'new'],
      defaultValue: 'old'
    },
    {
      name: 'placeholder',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'formFieldNameShow',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'formFieldSurnameShow',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'formFieldEmailShow',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'formFieldPhoneShow',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'formFieldHandleShow',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'formFieldSubjectShow',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'formFieldMessageShow',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'formFieldMessagePlaceholder',
      type: 'text',
      defaultValue: 'Details about your dog'
    },
    {
      name: 'footerImage',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'footerImageMobile',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'contactType',
      type: 'string',
      enum: ['CONTACT', 'PARTNERS']
    },
    {
      name: 'showEmbedForm',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'embedForm',
      type: 'richText',
      defaultValue: ''
    }
  ]
})
